import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { ICountryObject } from "app/services/CountryService";

import type { DeviceOption } from "../../types/commonFiltersDto";
import type {
    IAppsAndroidDownloadsAndEngagementDescriptionDto,
    IAppsIosDownloadsAndEngagementDescriptionDto,
} from "../../types/descriptionDto";
import type { IAppsIosDownloadsAndEngagementFilter } from "../../types/iosFiltersDto";
import { BaseDownloadsAndEngagementFilter } from "../DownloadEngagementFilter/BaseDownloadEngagementFilter";

interface IIosDownloadsAndEngagementOptions extends IAppsAndroidDownloadsAndEngagementDescriptionDto {
    devices: readonly DeviceOption[];
}

export default class FindIosDownloadAndEngagementFilter extends BaseDownloadsAndEngagementFilter<
    IAppsIosDownloadsAndEngagementFilter,
    IAppsIosDownloadsAndEngagementDescriptionDto
> {
    readonly devices: readonly DeviceOption[];

    constructor(
        deps: IFilterPanelBaseFilterDeps<
            IAppsIosDownloadsAndEngagementFilter,
            IAppsIosDownloadsAndEngagementDescriptionDto
        > & {
            options: IIosDownloadsAndEngagementOptions;
            countries: readonly ICountryObject[];
        },
    ) {
        super(deps);
        this.devices = deps.options.devices;
    }
}
